import { Button } from "@/components/ui/button";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import {
  Form,
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import { SubmitButton } from "@/components/ui/submit-button";
import VehicleSelect from "@/components/ui/vehicle-select";
import { errorHandler } from "@/lib/utils";
import { serviceOrderService } from "@/services/api/serviceOrder";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { useNavigate } from "react-router";
import { z } from "zod";
const formSchema = z.object({
  service_type: z.string().min(1, "Selecione o tipo de serviço"),
  vehicle_id: z.number().min(1, "Selecione um veículo"),
  contact: z.string().min(1, "Informe o contato"),
  client_id: z.number(),
  request_date: z.string().optional(),
  done: z.number().optional(),
  local: z.string().optional(),
  total_cost: z.number().optional(),
  charge_amount: z.number().optional(),
});

type FormValues = z.infer<typeof formSchema>;

const MyServiceOrdersForm = () => {
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const clientId = parseInt(
    localStorage.getItem("verden-client-id") ?? "0",
    10,
  );

  const form = useForm<FormValues>({
    resolver: zodResolver(formSchema),
    defaultValues: {
      service_type: "",
      vehicle_id: 0,
      contact: "",
      client_id: clientId,
      request_date: new Date().toISOString(),
      done: 0,
      local: "",
      total_cost: 0,
      charge_amount: 0,
    },
  });

  const onSubmit = async (values: FormValues) => {
    setLoading(true);
    try {
      await serviceOrderService.store(values);
      navigate("/my-service-orders");
    } catch (err) {
      errorHandler(err, "Erro ao criar ordem de serviço");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card className="mx-auto">
      <CardHeader>
        <CardTitle>Nova Ordem de Serviço</CardTitle>
      </CardHeader>
      <CardContent>
        <Form {...form}>
          <form onSubmit={form.handleSubmit(onSubmit)} className="space-y-6">
            {/* Campo: Tipo de Serviço */}
            <FormField
              control={form.control}
              name="service_type"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Tipo de Serviço</FormLabel>
                  <FormControl>
                    <Select value={field.value} onValueChange={field.onChange}>
                      <SelectTrigger>
                        <SelectValue placeholder="Selecione o tipo de serviço" />
                      </SelectTrigger>
                      <SelectContent>
                        <SelectItem value="Manutenção">Manutenção</SelectItem>
                        <SelectItem value="Retirada">Retirada</SelectItem>
                      </SelectContent>
                    </Select>
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="vehicle_id"
              render={({ field }) => (
                <FormItem className="flex flex-col">
                  <FormLabel>Veículo</FormLabel>
                  <VehicleSelect
                    value={field.value}
                    onChange={field.onChange}
                  />
                  <FormMessage />
                </FormItem>
              )}
            />

            <FormField
              control={form.control}
              name="contact"
              render={({ field }) => (
                <FormItem>
                  <FormLabel>Contato</FormLabel>
                  <FormControl>
                    <Input
                      type="text"
                      placeholder="Informe o contato"
                      {...field}
                    />
                  </FormControl>
                  <FormMessage />
                </FormItem>
              )}
            />

            <div className="flex justify-end space-x-2 pt-6">
              <Button
                type="button"
                variant="outline"
                onClick={() => navigate("/my-service-orders")}
              >
                Cancelar
              </Button>
              <SubmitButton loading={loading} />
            </div>
          </form>
        </Form>
      </CardContent>
    </Card>
  );
};

export default MyServiceOrdersForm;
